import { apiSlice } from '../apiSlice';
import { SuccessResponse, Paginated } from '../DTO/common.interface';

import {
	AddFaq,
	FaqPageFilter,
	InformationQaOverviewDTO,
	SortFaqListDTO,
} from '../DTO/information/faq.interface';

export const faqApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getFaqList: builder.query<
			SuccessResponse<Paginated<InformationQaOverviewDTO>>,
			FaqPageFilter
		>({
			query: (body) => ({
				url: `/web/information/qa-overview/page`,
				method: 'POST',
				body,
			}),
			providesTags: ['FaqList'],
		}),
		getFaqDetail: builder.query<
			SuccessResponse<InformationQaOverviewDTO>,
			string
		>({
			query: (id) => ({
				url: `/web/information/qa-overview/${id}`,
				method: 'GET',
			}),
		}),
		createFaq: builder.mutation<SuccessResponse<any>, AddFaq>({
			query: (body) => ({
				url: `/web/information/qa-overview`,
				method: 'POST',
				body,
			}),
			invalidatesTags: ['FaqList'],
		}),
		updateFaq: builder.mutation<SuccessResponse<any>, AddFaq>({
			query: (body) => ({
				url: `/web/information/qa-overview`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: ['FaqList'],
		}),
		sortFaqList: builder.mutation<
			SuccessResponse<any>,
			{ sortList: SortFaqListDTO[] }
		>({
			query: (body) => ({
				url: `/web/information/qa-overview/sort`,
				method: 'POST',
				body,
			}),
			invalidatesTags: ['FaqList'],
		}),
		deleteFaq: builder.mutation<SuccessResponse<any>, string>({
			query: (id) => ({
				url: `/web/information/qa-overview/${id}`,
				method: 'DELETE',
			}),
			invalidatesTags: ['FaqList'],
		}),
	}),
});

export const {
	useGetFaqListQuery,
	useCreateFaqMutation,
	useUpdateFaqMutation,
	useSortFaqListMutation,
	useDeleteFaqMutation,
	useGetFaqDetailQuery,
} = faqApiSlice;
